<template>
  <layout>
    <div slot="content" v-loading="shipInfoLoading">
      <i-card :title="$route.meta.title" contentWidth="80%">
        <div slot="content">
          <el-form :model="fields" label-width="150px" :rules="validateRules" size="small">
            <el-form-item label="商品名称" prop="title">
              <el-input v-model="fields.title"></el-input>
            </el-form-item>
            <el-form-item label="商品简称" prop="short_title">
              <el-input v-model="fields.short_title"></el-input>
            </el-form-item>
            <el-form-item label="分享描述" prop="share_content">
              <el-input v-model="fields.share_content"></el-input>
            </el-form-item>
            <el-form-item label="排序(数值大的靠前)" prop="share_content">
              <el-input v-model="fields.list_order"></el-input>
            </el-form-item>
            <el-form-item label="促销标签" prop="share_content">
              <el-tag size="small" closable @close="delLabel(index)"
                      style="margin-right: 10px;"
                      :key="'tag_'+index"
                      v-for="(item,index) in fields.labels">{{ item }}
              </el-tag>
              <el-button size="mini" type="primary" @click="addLabel" v-if="fields.labels.length<3">
                添加标签
              </el-button>
            </el-form-item>
            <el-form-item label="商品图片" prop="origin_images">
              <i-upload v-model="fields.origin_images"></i-upload>
            </el-form-item>
            <el-form-item label="封面小图" prop="origin_mini_images">
              <i-upload v-model="fields.origin_mini_images" :max-files="1"></i-upload>
            </el-form-item>
            <el-form-item label="产品分类" prop="share_content">
              <el-transfer :titles="['全部分类', '已选分类']" v-model="fields.cates"
                           :data="allCate"></el-transfer>
            </el-form-item>
            <el-form-item label="绑定供应商">
              <el-alert title="需要关注公众号，并且绑定后才可接收到下单通知" type="warning"
                        style="padding:0 5px;margin-bottom: 10px;width: 55%" :closable="false">
                <div style="padding-bottom: 10px;">
                  <el-button size="mini" type="primary" @click="showQrCode('qr-focus')">点击扫码关注
                  </el-button>
                  <el-button size="mini" type="primary" @click="showQrCode('qr-bind')">点击扫码绑定
                  </el-button>
                </div>
              </el-alert>
              <el-select v-model="fields.provider_user_id" placeholder="请选择供应商" style="width: 55%"
                         :clearable="true">
                <el-option
                  v-for="item in providerList"
                  :key="item.uuid"
                  :label="item.nickname+'('+item.province+' '+item.city+')'"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优惠券" prop="sale_status">
              <el-select v-model="fields.coupon_id" placeholder="请选择" style="width: 100%">
                <el-option label="请选择优惠券" value="0"></el-option>
                <el-option :label="coupon.label" :value="coupon.value" v-for="coupon in couponList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="当前销量"  prop="sale_count">
              <el-input type="text" placeholder="请设置当前销量" v-model="fields.sale_count" />
            </el-form-item>
            <el-form-item label="客服电话"  prop="service_phone">
              <el-input type="text" placeholder="该电话将在订单处显示，优先级高于全局客服电话" v-model="fields.service_phone" />
            </el-form-item>
            <el-form-item label="跳转小程AppID"  prop="link_app_id">
              <el-input type="text" placeholder="跳转小程序的appid" v-model="fields.link_app_id" />
            </el-form-item>
            <el-form-item label="跳转小程路径"  prop="link_app_path">
              <el-input type="text" placeholder="跳转小程路径" v-model="fields.link_app_path" />
            </el-form-item>
            <el-form-item label="支付商户" prop="sale_status">
              <el-select v-model="fields.pay_config" placeholder="请选择" style="width: 100%">
                <el-option label="鼓浪屿散拼游学(1676745796)" value="pay_ziyoumaolvyou"></el-option>
                <el-option label="三只骆驼(1709575892)" value="pay_sanzhiluotuo"></el-option>
                <el-option label="厦门市思明区丽楚花酒业商行(1729318160)" value="pay_lichuhua"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单管理员组">
              <el-select v-model="fields.admin_group_id" placeholder="请选择" style="width: 100%" clearable>
                <el-option :label="'未选择'" :value="0"></el-option>
                <el-option v-for="g in adminGroupOptions" :key="g.id" :label="g.name" :value="g.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="绑定合同模板">
              <div style="display:flex;align-items:center;gap:8px">
                <el-select v-model="fields.contract_template_id" placeholder="请选择合同模板（选填）" style="flex:1" clearable>
                  <el-option :label="'不绑定'" :value="0"></el-option>
                  <el-option
                    v-for="t in contractTemplateOptions"
                    :key="t.id"
                    :label="t.name"
                    :value="t.id">
                  </el-option>
                </el-select>
                <el-button size="small" type="text" icon="el-icon-setting" @click="goToTemplateManage">模板管理</el-button>
              </div>
              <div style="font-size:12px;color:#909399;margin-top:4px">绑定后，订单的"查看合同"功能将基于该模板渲染合同内容</div>
            </el-form-item>
            <el-form-item label="绑定供应商">
              <div style="display:flex;align-items:center;gap:8px">
                <el-select
                  v-model="fields.supplier_ids"
                  multiple
                  filterable
                  placeholder="请选择供应商（可多选）"
                  style="flex:1"
                >
                  <el-option
                    v-for="s in supplierOptions"
                    :key="s.id"
                    :label="s.name"
                    :value="s.id">
                  </el-option>
                </el-select>
                <el-button size="small" type="text" icon="el-icon-office-building" @click="goToSupplierManage">供应商管理</el-button>
              </div>
              <div style="font-size:12px;color:#909399;margin-top:4px">下单时供应商信息将自动写入订单，并在合同中呈现</div>
            </el-form-item>
            <el-form-item label="上架销售" prop="sale_status">
              <el-switch v-model="fields.sale_status"></el-switch>
            </el-form-item>
            <el-form-item label="首页展示" prop="sale_status">
              <el-switch v-model="fields.is_homepage_status"></el-switch>
            </el-form-item>
            <el-form-item label="是否展示销量" prop="sale_status">
              <el-switch v-model="fields.show_sale_count_status"></el-switch>
            </el-form-item>
            <el-form-item label="自动出票" prop="sale_status">
              <el-switch v-model="fields.auto_check_status"></el-switch>
            </el-form-item>
            <el-form-item label="地址信息" prop="details">
              <i-map @confirm="getAddress" :address="fields.address"/>
            </el-form-item>
            <el-form-item label="产品详情" prop="details">
              <i-editor type="textarea" v-model="fields.details"></i-editor>
            </el-form-item>
            <el-form-item label="预定须知" prop="details">
              <i-editor type="textarea" v-model="fields.ydxz"></i-editor>
            </el-form-item>
            <el-form-item label="出行提示" prop="details">
              <el-input type="textarea" rows="8" v-model="fields.tips"></el-input>
            </el-form-item>
            <el-form-item label="详情字段" prop="details">
              <i-field v-model="fields.details_field"/>
            </el-form-item>
            <el-form-item label="票券规格" prop="sku_infos">
              <i-sku v-model="fields.sku_infos" :need-play-list="productType === 14"></i-sku>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="sub">立即提交</el-button>
              <el-button @click="$router.back()">返回列表</el-button>
            </el-form-item>
          </el-form>
        </div>
      </i-card>
      <el-dialog title="请用微信扫一扫" :visible.sync="showDialog" width="20%">
        <div style="text-align: center">
          <img :src="qrCode" width="80%">
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import iSku from '@/components/i-sku'
import iMap from '@/components/i-map'
import iEditor from '@/components/i-editor'
import iField from '@/components/i-field'
import qrBind from "@/assets/images/qr-bind.png"
import qrFocus from "@/assets/images/qr-focus.png"

export default {
  name: "add_ship",
  components: {iSku, iEditor, iMap, iField},
  data: function () {
    return {
      showDialog: false,
      qrCode: '',
      validateRules: {
        title: [
          {required: true, message: '请输入套餐名称', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'}
        ],
        origin_images: [
          {required: true, message: '请上传图片', trigger: 'blur'},
        ],
        share_content: [
          {required: false, message: '', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'}
        ],
        on_sale: [
          {required: true, message: '请选择是否需要商家销售', trigger: 'blur'},
        ],
        pay_config: [
          {required: true, message: '请选择支付商户', trigger: 'blur'},
        ],
        sku_infos: [
          {required: true, message: '请至少添加一种规格', trigger: 'blur'},
        ]
      },
      fields: {
        title: '',
        short_title: '',
        share_content: '',
        origin_images: [],
        origin_mini_images: [],
        sale_status: true,
        sku_infos: {},
        details: '',
        labels: [],
        cates: [],
        provider_user_id: '',
        ydxz: '',
        auto_check_status: false,
        list_order: 0,
        is_homepage_status: true,
        show_sale_count_status: true,
        pay_config: '',
        address: {},
        tips: '',
        details_field: [],// 详情字段
        coupon_id: "",// 优惠券
        service_phone: "",// 客服电话
        link_app_id: "",// 跳转的小程序id
        link_app_path: "",// 跳转的小程序路径
        admin_group_id: 0,// 订单管理员组，未选择为0
        contract_template_id: 0,// 绑定的合同模板ID，0表示未绑定
        supplier_ids: [],// 绑定的供应商ID列表
      },
      isCreate: true,
      loading: false,
      shipInfoLoading: false,
      productType: 11,
      allCate: [],
      providerList: [],
      couponList: [],
      adminGroupOptions: [], // 管理员组下拉
      contractTemplateOptions: [], // 合同模板下拉
      supplierOptions: [], // 供应商下拉
      sale_count: ''
    }
  },
  methods: {
    sub: function () {
      this.loading = true;
      let params = JSON.stringify(this.fields);
      params = JSON.parse(params);
      // 未选择管理员组时传0，并转为数字
      params.admin_group_id = Number(this.fields.admin_group_id || 0);
      params.images = [];
      for (let i in this.fields.origin_images) {
        params.images.push(this.fields.origin_images[i].path);
      }
      params.on_sale = this.fields.sale_status ? 1 : -1;
      params.auto_check = this.fields.auto_check_status ? 1 : -1;
      params.type = this.productType;
      params.is_homepage = this.fields.is_homepage_status ? 1 : -1;
      params.show_sale_count = this.fields.show_sale_count_status ? 1 : -1;
      if (this.fields.origin_mini_images.length > 0) {
        params.mini_cover = this.fields.origin_mini_images[0].path;
      } else {
        params.mini_cover = '';
      }
      params.address = JSON.stringify(this.fields.address)

      let url = this.isCreate ? 'addProduct' : 'editProduct';
      this.$http.request(url, params).then((res) => {
        if (res.status === 'success') {
          let _self = this;
          this.$message({
            message: res.message,
            type: 'success',
            onClose: function () {
              _self.loading = false;
              _self.$router.back();
            }
          });
        } else {
          this.loading = false;
        }
      });
    },
    getProductType: function () {
      let path = this.$route.path.split('/');
      let action = path[path.length - 1];
      let type = action.split('_')[1];
      switch (type) {
        case 'trip':
          this.productType = 10;
          break;
        case 'ship':
          this.productType = 11;
          break;
        case 'scenic':
          this.productType = 12;
          break;
        case 'booking':
          this.productType = 14;
          break;
      }
    },
    getShipInfo: function () {
      let productId = this.$route.query.product_id;
      let _self = this;
      if (productId) {
        this.isCreate = false;
        this.shipInfoLoading = true;
        this.$http.request('productInfo', {product_id: productId}).then((res) => {
          // 合并到已有字段，保留默认值（如 admin_group_id: 0）
          _self.fields = Object.assign({}, _self.fields, res.data || {});
          if (typeof _self.fields.admin_group_id === 'undefined' || _self.fields.admin_group_id === null) {
            _self.fields.admin_group_id = 0;
          }
          // 供应商ID回显：接口返回数组，直接赋值
          if (!Array.isArray(_self.fields.supplier_ids)) {
            _self.fields.supplier_ids = [];
          }
          // 处理 show_sale_count 字段的回显
          if (typeof _self.fields.show_sale_count !== 'undefined') {
            _self.fields.show_sale_count_status = _self.fields.show_sale_count === 1;
          } else {
            _self.fields.show_sale_count_status = false;
          }
          _self.shipInfoLoading = false;
        });
      }
    },
    delLabel: function (index) {
      this.fields.labels.splice(index, 1);
    },
    addLabel: function () {
      this.$prompt('请输入标签名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        this.fields.labels.push(value);
      })
    },
    getCate: function () {
      this.$http.request('cateList').then(res => {
        res.data.forEach((row, index) => {
          this.allCate.push({key: row.id, label: row.cate_name, disabled: false});
        })
      });
    },
    getCoupon: function () {
      this.$http.request('couponListOptions').then(res => {
        this.couponList = res.data;
      });
    },
    getProvider: function () {
      this.$http.request('providerUserList').then(res => {
        this.providerList = res.data;
      });
    },
    getAdminGroupList: function () {
      this.$http.request('AdminGroupList').then(res => {
        this.adminGroupOptions = res.data || [];
      });
    },
    getContractTemplateList: function () {
      this.$http.request('contractTemplateList', { page: 1, per_page: 200 }).then(res => {
        if (res && res.data && res.data.data) {
          this.contractTemplateOptions = res.data.data.filter(t => t.status === 1);
        }
      });
    },
    goToTemplateManage: function () {
      const route = this.$router.resolve({ name: 'contract.template_list' });
      window.open(route.href, '_blank');
    },
    getSupplierList: function () {
      this.$http.request('allSuppliers').then(res => {
        if (res && res.data) {
          this.supplierOptions = res.data;
        }
      });
    },
    goToSupplierManage: function () {
      const route = this.$router.resolve({ name: 'supplier.list' });
      window.open(route.href, '_blank');
    },
    showQrCode: function (imageName) {
      this.showDialog = true;
      if (imageName === 'qr-bind') {
        this.qrCode = qrBind;
      } else {
        this.qrCode = qrFocus;
      }
    },
    getAddress: function (address) {
      this.fields.address = address;
    }
  },
  created: function () {
    this.getShipInfo();
    this.getProductType();
    this.getCate();
    this.getProvider();
    this.getCoupon();
    this.getAdminGroupList();
    this.getContractTemplateList();
    this.getSupplierList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/add_product.vue